module.exports = __webpack_public_path__ + "img/shenhr.c5d78c8e.png";